import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, ReplaySubject, Observable, timer, takeUntil } from 'rxjs';

export enum SyncEventType {
  INITIAL_UNKNOWN,
  OFFLINE,
  ONLINE,
  SYNCHRONIZING,
  SUCCESS,
  FAIL
}

export enum ApprovedStatus {
  APPROVED = 'approved',
  PRE_APPROVAL = 'pre_approval',
  UNKNOWN = 'unknown',
}
@Injectable({
  providedIn: 'root'
})
export class StateService {

  isCallOngoing = new BehaviorSubject<boolean>(false);
  dateChanged$ = new ReplaySubject<boolean>();
  public events$ = new ReplaySubject<SyncEventType>(1);
  private _onboardingComplete$ = new ReplaySubject<void>(1);
  public onboardingComplete$ = this._onboardingComplete$.asObservable();
  private patientStatus$ = new ReplaySubject<ApprovedStatus>(1);
  private loggedIn$ = new ReplaySubject<boolean>(1);

  constructor() {
    this.dateChanged$.next(false);
    this.events$.next(SyncEventType.INITIAL_UNKNOWN);

    // Set default values after 3 seconds if not already set
    // Using a separate flag to track if value was set before timeout
    let loggedInSet = false;
    let patientStatusSet = false;

    const loggedInSub = this.loggedIn$.subscribe(() => {
      loggedInSet = true;
    });

    const patientStatusSub = this.patientStatus$.subscribe(() => {
      patientStatusSet = true;
    });

    timer(3000).subscribe(() => {
      if (!loggedInSet) {
        this.loggedIn$.next(false);
      }
      loggedInSub.unsubscribe();
    });

    timer(3000).subscribe(() => {
      if (!patientStatusSet) {
        this.patientStatus$.next(ApprovedStatus.UNKNOWN);
      }
      patientStatusSub.unsubscribe();
    });
  }

  setLoggedInStatus(loggedIn: boolean) {
    this.loggedIn$.next(loggedIn);
  }

  getLoggedInStatus() {
    return this.loggedIn$.asObservable();
  }

  getPatientStatus(): Observable<ApprovedStatus> {
    return this.patientStatus$.asObservable();
  }

  setPatientStatus(status: ApprovedStatus) {
    this.patientStatus$.next(status);
  }

  setTelehealthCallStatus(status: boolean) {
    this.isCallOngoing.next(status);
  }

  isTelehealthCallOngoing(): boolean {
    return this.isCallOngoing.value;
  }

  markOnboardingComplete(): void {
    this._onboardingComplete$.next();
  }

}
